import React from 'react'
import styles from './scrollArea.module.css'
import * as ScrollAreaRadix from "@radix-ui/react-scroll-area";

export function ScrollArea({ data, keey, val }) {
    return (
        <ScrollAreaRadix.Root className={styles.Root}>
            <ScrollAreaRadix.Viewport className={styles.Viewport}>

                <div >
                    {data ? data.map((item, id) => (
                        <div className={styles.Tag} key={id}>
                            {item[keey]} {item[val]}

                        </div>
                    )) : <div>empty</div>}
                </div>
            </ScrollAreaRadix.Viewport>
            <ScrollAreaRadix.Scrollbar className={styles.Scrollbar} orientation="vertical">
                <ScrollAreaRadix.Thumb className={styles.Thumb} />
            </ScrollAreaRadix.Scrollbar>
        </ScrollAreaRadix.Root>
    )
}
